var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(1790 496)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1790 -496)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1791.229 497.623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.31,7.882a3.469,3.469,0,0,0-6.45-1.774v0c-.029.049-.057.1-.084.149l-.013.026c-.023.043-.044.086-.065.13l-.018.041c-.018.039-.035.079-.052.12l-.02.05c-.015.038-.028.075-.042.114l-.019.058c-.012.037-.023.074-.034.112-.006.021-.012.042-.018.063s-.019.073-.028.109-.011.045-.015.066c-.008.037-.015.074-.021.109s-.008.045-.012.069-.011.076-.015.115c0,.022-.006.045-.008.067,0,.042-.007.083-.01.126,0,.019,0,.039,0,.059,0,.062-.005.123-.005.186s0,.109,0,.159v.035q0,.076.012.153l0,.026c0,.046.01.092.017.136a.073.073,0,0,0,0,.028c.008.049.017.1.026.147a.205.205,0,0,0,.007.035c.01.046.021.093.032.139v.01c.012.049.026.1.041.142l.012.037c.015.046.03.091.046.136,0,.01.007.019.011.029.015.039.03.077.045.115,0,.012.008.022.014.033.018.043.038.085.058.128l.018.036c.019.038.038.075.058.113a3.484,3.484,0,0,0,1.2,1.289,3.37,3.37,0,0,0,.413.225l.021.01q.144.065.294.117l.052.017.081.025.074.021.1.027.094.022.062.012.1.018.051.008c.049.007.1.014.147.019l.042,0,.119.008.046,0c.054,0,.1,0,.158,0s.125,0,.186-.005l.059,0,.126-.01.068-.008.114-.015.069-.012.109-.021.066-.015c.037-.008.074-.017.109-.028l.063-.018.112-.034.058-.019.114-.042.05-.02c.041-.016.081-.034.12-.052l.041-.018c.044-.021.087-.042.13-.065l.026-.013c.05-.027.1-.054.149-.084h0a3.494,3.494,0,0,0,.835-.689A3.456,3.456,0,0,0,32.31,7.882Z",
    transform: "translate(-4.975)",
    fill: "#333",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.587,12.153,14.87,16.6a.866.866,0,0,1-1.064,0l-7.8-6.065A.866.866,0,1,1,7.072,9.166l7.266,5.652,5.1-3.968a5.191,5.191,0,0,1-.076-5.332H5.24A3.036,3.036,0,0,0,2.207,8.55v13A3.036,3.036,0,0,0,5.24,24.581h18.2a3.036,3.036,0,0,0,3.033-3.033V12.622a5.191,5.191,0,0,1-5.882-.469Z",
    transform: "translate(0 -0.238)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.21c3a2044d79f3566d3df39e9bfa2b8e.svg";
export { ForwardRef as ReactComponent };